import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import Layout from '../../components/Layout';
import toast from 'react-hot-toast';

const C = { teal:'#00B4D8', success:'#10B981', dark:'#1F2937', grey:'#6B7280', border:'#E5E7EB' };
const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
const HOURS = Array.from({length:16}, (_,i) => i+6); // 6am to 9pm

export default function TutorAvailability() {
  const [available, setAvailable] = useState({});
  const [buffer, setBuffer] = useState(15);
  const [saving, setSaving] = useState(false);

  // Load saved availability on mount
  useEffect(() => {
    api.get('/api/tutor/availability').then(res => {
      // Convert {day_of_week: [hours]} to {`${dayName}-${hour}`: true}
      const slotMap = res.data.availability || {};
      const avail = {};
      const DAYS_LIST = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
      Object.entries(slotMap).forEach(([dow, hours]) => {
        const dayName = DAYS_LIST[parseInt(dow)];
        (hours || []).forEach(h => { avail[`${dayName}-${h}`] = true; });
      });
      setAvailable(avail);
    }).catch(() => {});
  }, []);

  const saveAvailability = async () => {
    setSaving(true);
    try {
      const DAYS_LIST = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
      const slotMap = {};
      Object.entries(available).forEach(([key, val]) => {
        if (!val) return;
        const [dayName, hourStr] = key.split('-');
        const dow = DAYS_LIST.indexOf(dayName);
        if (dow >= 0) {
          slotMap[dow] = slotMap[dow] || [];
          slotMap[dow].push(parseInt(hourStr));
        }
      });
      await api.post('/api/tutor/availability', slotMap);
      toast.success('Availability saved!');
    } catch {
      toast.error('Failed to save. Please try again.');
    }
    setSaving(false);
  };

  const toggle = (day, hour) => {
    const key = `${day}-${hour}`;
    setAvailable(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Layout role="tutor">
      <div className="card" style={{ padding:24, marginBottom:20 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <h3 style={{ margin:0, fontSize:16, fontWeight:700 }}>Weekly Availability</h3>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <label style={{ fontSize:13, color:C.grey }}>Buffer between lessons:</label>
            <select value={buffer} onChange={e => setBuffer(Number(e.target.value))}
              style={{ padding:'6px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14 }}>
              {[0,15,30,60].map(v => <option key={v} value={v}>{v === 0 ? 'None' : `${v} min`}</option>)}
            </select>
          </div>
        </div>
        <div style={{ overflowX:'auto' }}>
          <table style={{ borderCollapse:'collapse', minWidth:700 }}>
            <thead>
              <tr>
                <th style={{ padding:'8px 12px', fontSize:12, color:C.grey, fontWeight:600, textAlign:'left', minWidth:60 }}>Time</th>
                {DAYS.map(d => (
                  <th key={d} style={{ padding:'8px 12px', fontSize:12, color:C.grey, fontWeight:600, textAlign:'center', minWidth:70 }}>{d.slice(0,3)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {HOURS.map(hour => (
                <tr key={hour}>
                  <td style={{ padding:'4px 12px', fontSize:12, color:C.grey, fontWeight:500 }}>
                    {hour.toString().padStart(2,'0')}:00
                  </td>
                  {DAYS.map(day => {
                    const key = `${day}-${hour}`;
                    const isAvail = available[key];
                    return (
                      <td key={day} style={{ padding:2, textAlign:'center' }}>
                        <div
                          onClick={() => toggle(day, hour)}
                          style={{
                            height:28, borderRadius:4, cursor:'pointer',
                            background: isAvail ? C.success : '#F3F4F6',
                            border: `1px solid ${isAvail ? C.success : C.border}`,
                            transition:'all 0.15s',
                          }}
                          title={`${day} ${hour}:00`}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display:'flex', gap:16, marginTop:16, alignItems:'center' }}>
          <div style={{ display:'flex', alignItems:'center', gap:6 }}>
            <div style={{ width:16, height:16, borderRadius:3, background:C.success }} />
            <span style={{ fontSize:13, color:C.grey }}>Available</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:6 }}>
            <div style={{ width:16, height:16, borderRadius:3, background:'#F3F4F6', border:`1px solid ${C.border}` }} />
            <span style={{ fontSize:13, color:C.grey }}>Unavailable</span>
          </div>
        </div>
      </div>
      <button onClick={saveAvailability} disabled={saving} className="btn-teal" style={{ padding:'12px 32px', opacity: saving ? 0.7 : 1 }}>
        {saving ? 'Saving...' : 'Save Availability'}
      </button>
    </Layout>
  );
}
